export const CpRuleSchema = {
    source: 'source',
    destination: 'destination',
    sourceDestinationSchema: {
        type: 'type',
        zone: 'zone',
        ipSingle: 'ipSingle',
        domain: 'domainName',
        domainObject: 'domainObject',
        updatableObjectCode: 'objCodeName',
        ipStart: 'ipStart',
        ipEnd: 'ipEnd',
        ipNetwork: 'ipNetwork',
        ipMask: 'ipMask',
        ipV6Single: 'ipV6Single',
        ipV6Start: 'ipV6Start',
        ipV6End: 'ipV6End',
        ipV6Network: 'ipV6Network',
        ipV6Prefix: 'ipV6Prefix',
        ipV6ObjectName: 'ipV6ObjectName',

    },
    serviceOrApplication: 'serviceOrApplication',
    service: 'service',
    serviceSchema: {
        type: 'type',
        customType: 'customType',
        name: 'name',
        ports: 'ports',
        icmpType: 'icmpType',
        icmpCode: 'icmpCode',
        ipProtocol: 'ipProtocol'
    },
    application: 'application',
    applicationSchema: {
        type: "type",
        predefinedAppId: "predefinedAppId",
        customUrlValue: "customUrlValue",
        customUrlName: "customUrlName",
        customUrlIsRegex: "customUrlIsRegex",
    },
    action: 'action',
    log: 'log',
    description: 'description',
    enabled: 'enabled'
}

export const SourceDestinationTypeValues = {
    ANY: 'ANY',
    HOST: 'HOST',
    IP_RANGE: 'IP_RANGE',
    NETWORK: 'NETWORK',
    ZONE: 'ZONE',
    INTERNET: 'INTERNET',
    DOMAIN: 'DOMAIN',
    DOMAINOBJECT: 'DOMAINOBJECT',
    IPV6_HOST: 'IPV6_HOST',
    IPV6_RANGE: 'IPV6_RANGE',
    IPV6_NETWORK: 'IPV6_NETWORK',
    UPDATABLE_OBJECTS: 'UPDATABLE_OBJECTS'
}

export const SourceDestinationZoneValues = {
    INTERNET: 'INTERNET',
    LAN: 'LAN',
    DMZ: 'DMZ',
    LAN_DMZ: 'LAN_DMZ',
    TRUSTED_WLAN: 'TRUSTED_WLAN',
    UNTRUSTED_WLAN: 'UNTRUSTED_WLAN',
    GATEWAY: 'GATEWAY',
    USERS: 'USERS',
    REMOTE_ACCESS: 'REMOTE_ACCESS',
    WIRELESS: 'WIRELESS'
}

export const ServiceTypeValues = {
    ANY: 'ANY',
    CUSTOM: 'CUSTOM',
    ANY_TCP: 'ANY_TCP',
    ANY_UDP: 'ANY_UDP',
    HTTP: 'HTTP',
    HTTPS: 'HTTPS',
    FTP: 'FTP',
    SNMP: 'SNMP',
    SSH: 'SSH',
    TFTP: 'TFTP',
    TELNET: 'TELNET',
    POP3: 'POP3',
    ICMP: 'ICMP',
    IMAP: 'IMAP',
    SMTP: 'SMTP',
    DHCP: 'DHCP',
    CIFS: 'CIFS',
    DNS_TCP: 'DNS_TCP',
    DNS_UDP: 'DNS_UDP',
    LDAP: 'LDAP',
    SIP_TCP: 'SIP_TCP',
    SIP_UDP: 'SIP_UDP',
    DNS: 'DNS',
    MAIL: 'MAIL',
    NETBIOS: 'NETBIOS',
    WEB_BROWSING: 'WEB_BROWSING',
    ANY_TCP_UDP: 'ANY_TCP_UDP',
    DELAY_SENSITIVE_SERVICES: 'DELAY_SENSITIVE_SERVICES',
    GUARANTEED_BANDWIDTH_SERVICES: 'GUARANTEED_BANDWIDTH_SERVICES',
    VOIP: 'VOIP',
    SIP: 'SIP'
}

export const ServiceCustomTypeValues = {
    TCP: 'TCP',
    UDP: 'UDP',
    ICMP: 'ICMP',
    OTHER: 'OTHER'
}

export const ApplicationTypeValues = {
    ANY: 'ANY',
    PREDEFINED: 'PREDEFINED',
    CUSTOM_URL: 'CUSTOM_URL'
}

export const ServiceOrAppiValues = {
    SERVICE: 'SERVICE',
    APPI: 'APPI'
}

export const ActionValues = {
    ACCEPT: 'ACCEPT',
    BLOCK: 'BLOCK'
}

export const LogValues = {
    NONE: 'NONE',
    LOG: 'LOG',
    ALERT: 'ALERT',
    ACCOUNT: 'ACCOUNT'
}